<template>
  <LayoutPage :title="pageTitle">
    <v-sheet v-if="src" class="embedded-wrapper">
      <iframe :src="src" frameborder="0" class="embedded-content"></iframe>
    </v-sheet>
  </LayoutPage>
</template>

<script>
import LayoutPage from "@layout/LayoutPage.vue";
import useUser from "./useUser";
import useDashboardTitle from "../dashboard/useDashboardTitle";
import { addUrlParams } from "@components/common/helpers/datastudio";
import { computed, unref } from "vue";
import { timeZoneOffset } from "@tod-ui/helpers/datetime";

export default {
  name: "PageManagementDashboard",
  components: {
    LayoutPage,
  },
  setup() {
    const { defaultOrganization } = useUser();
    const pageTitle = useDashboardTitle("Management Dashboard");

    const src = computed(() => {
      const userOrganization = unref(defaultOrganization);
      return addUrlParams(
        import.meta.env.VUE_APP_EMBEDDED_MANAGEMENT_DASHBOARD_URL,
        {
          id: userOrganization.id,
          mdiff: timeZoneOffset(userOrganization.timeZone),
        }
      );
    });

    return { defaultOrganization, pageTitle, src };
  },
};
</script>
